<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget ref="base" :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       style="position: relative">
    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 2"
    >
      <div class="fs-14 color-33">左右间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.hSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>
    <div
      class="h-30 flex a-center m-v-10 color-33"
      v-if="iteminfo.config.displayType === 2"
    >
      <div class="fs-14 color-33">上下间距：</div>
      <Input
        class="fr w-100 m-l-20"
        type="number"
        v-model="iteminfo.config.vSpacing"
      >
        <span slot="append">px</span>
      </Input>
    </div>

    <div class="fs-14 color-33">
      上传图片
    </div>
    <div class="fs-12 color-99 m-v-10" style="margin-right: 0px">
      建议图片尺寸为750*262，图片格式为png或jpg，图片大小不超过5Mb
    </div>

    <ul class="p-b-50">
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
          v-for="(item,index) in iteminfo.config.datalist">
        <div class="flex" style="min-height: 100px">
          <div class="flex-1 p-v-20 p-l-20">
            <div class="flex" style="min-height: 100px">
              <div class="flex-1 flex a-center j-center"
                   v-if="iteminfo.config.displayType === 2">
                <div style="height: 115px;width: 100%" class="flex a-center o-hidden">
                  <img :src="getItemUrl(item)" alt="" style="width: 100%;cursor:pointer"
                       @click="choicePic(item)">
                </div>
              </div>
              <div class="flex-1 flex a-center" v-if="iteminfo.config.displayType===1">
                <div style="position: relative">
                  <img :src="getItemUrl(item)" alt=""
                       style="width: 60px;height: 60px;border-radius: 30px;cursor:pointer"
                       @click="choicePic(item)"
                  >
                  <!--删除按钮-->
                  <img class="w-15 h-15 absolute" style="cursor:pointer;right: -5px;top: 0"
                       v-if="item.picurl"
                       @click="deleteChoicePice(item)"
                       src="../../../assets/common/ic_yichu.png"/>
                </div>

                <div class="flex-1 p-l-10 flex-column" style="height: 80px;align-items: flex-start">
                  <Input class="" placeholder="导航名称" maxlength="6" style=""
                         v-model="item.name"></Input>
                  <tooltip style="width: 100%"
                           :disabled="!item.jumpObj.linkUrl"
                           max-width="250">

                    <Input class="m-t-10" placeholder="跳转链接地址" style="background-color: white"
                           readonly clearable
                           v-model="item.jumpObj.linkUrl">
                                        <span style="cursor:pointer" slot="append"
                                              @click="showMaterialModal(item,index)">
                                          <i class="icon-link"/>
                                        </span>
                    </Input>
                    <div slot="content" style="white-space: normal;">
                      {{ item.jumpObj.linkUrl }}
                    </div>
                  </tooltip>
                </div>
              </div>
              <div class="flex-1 flex a-center j-center"
                   v-if="iteminfo.config.displayType===3">
                <img :src="getItemUrl(item)" alt=""
                     style="width: 100%;height: 216px;cursor: pointer"
                     @click="choicePic(item)">
              </div>

              <div class="flex-column a-center flex-s-0"
                   style="width: 50px;justify-content: space-around;">
                <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                   class="icon-up fs-18"
                   style="cursor: pointer;"/>
                <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                   @click.stop="onDownClick(index)"
                   class="icon-down fs-18"
                   style="cursor: pointer;"/>
                <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                   style="cursor: pointer;color: #666666"/>
              </div>
            </div>
            <div class="bg-white flex border m-t-10" style="height: 34px;margin-right: 50px"
                 v-if="iteminfo.config.displayType===3 || iteminfo.config.displayType === 2">
              <Input :border="false" class="b-r" placeholder="导航名称" style="width: 100px"
                     v-model="item.name"></Input>
              <tooltip style="width: 100%"
                       :disabled="!item.jumpObj.linkUrl"
                       max-width="250">

                <Input :border="false"
                       class="input-link"
                       readonly clearable
                       placeholder="跳转链接地址" v-model="item.jumpObj.linkUrl">
                  <span slot="append" style="cursor: pointer"
                        @click="showMaterialModal(item,index)">  <i class="icon-link"/> </span>
                </Input>
                <div slot="content" style="white-space: normal;">
                  {{ item.jumpObj.linkUrl }}
                </div>
              </tooltip>
            </div>
          </div>

        </div>
      </li>

    </ul>

    <div class="p-b-20"
         style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
      <div @click="onItemAddClick" class="flex a-center j-center" key="abc"
           style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
        <Icon size="24" type="ios-add"/>
        <div class="m-l-2">添加{{ iteminfo.name }}导航</div>
      </div>
    </div>
    <pic-choice-widget
      ref="picChoiceWidget"
      :on-ok="picChoiceOk"
    />
    <material-choice-widget
      title="选择链接"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'

export default {
  name: 'NavSettingWidget',
  components: {MaterialChoiceWidget, PicChoiceWidget, UpLoadImage, BaseSettingWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      showTooltip: false,
      showPicChoiceModal: false,
      datalist: [],
      clickItem2ShowPicModal: {},
      clickItem2ShowMaterialModal: {},
    }
  },
  mounted () {
    this.init()
  },

  watch: {
    'iteminfo.config.datalist': {
      handler (newV) {
        let displayType = this.iteminfo.config.displayType

        let maxCountPerRow = 2
        if (displayType === 2) {         //卡片式
          maxCountPerRow = 2
        } else if (displayType === 1) { //图标式
          maxCountPerRow = 4
        }
        if (newV) {
          let length = newV.length
          this.iteminfo.config.rowCount = Math.ceil(length / maxCountPerRow)
          this.iteminfo.config.columnCount = length > maxCountPerRow ? maxCountPerRow : length
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    init () {
    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push(this.getEmptyItem())
      this.$nextTick(() => {
        if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
          let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
          this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
        }
      })
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      let datalist = this.iteminfo.config.datalist
      datalist.splice(index, 1)
      if (!datalist.length) {
        this.onItemAddClick()
      }
      // let minCount = this.getMinCount()
      // let datalist = this.iteminfo.config.datalist
      // if (datalist && datalist.length > minCount) {      //大于最小数量的时候,删除
      //   this.iteminfo.config.datalist.splice(index, 1)
      // } else {
      //   if (index > -1 && index < datalist.length) {
      //     datalist[index].picurl = ''
      //     datalist[index].contentLink = ''
      //     datalist[index].width = 0
      //     datalist[index].height = 0
      //
      //     datalist[index].jumpObj.linkUrl = ''
      //     datalist[index].name = ''
      //   }
      // }
    },
    getItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_nav_card.png')
      } else if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/common/ic_blue_add.png')
      } else if (this.iteminfo.config.displayType === 3) {
        src = require('../../../assets/tempmenu/img_carousel.png')
      }
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDataList () {
      this.datalist = [
        {
          id: 1,
          clazz: '分类1',
          group: '分组1',
          picName: '标题1标题1标题1标题1标题1标题1标题1',
          createBy: 'zgh',
          imgUrl: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc095b97f2286163a5fa49f63fd72e32917aa2ce63f5f1421b38fb4685d7e6af3',
          createTime: '2022-10-10 12:00:00',
        }, {
          id: 2,
          clazz: '分类2',
          group: '分组2',
          picName: '标题2',
          createBy: 'zgh',
          imgUrl: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc095b97f2286163a5fa49f63fd72e32917aa2ce63f5f1421b38fb4685d7e6af3',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        }, {
          id: 3,
          clazz: '分类3',
          group: '分组3',
          picName: '标题3',
          createBy: 'zgh',
          imgUrl: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc095b97f2286163a5fa49f63fd72e32917aa2ce63f5f1421b38fb4685d7e6af3',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        }, {
          id: 4,
          clazz: '分类4',
          group: '分组4',
          picName: '标题4',
          createBy: 'zgh',
          imgUrl: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng27ff8791cb506042fcbe0e1e899de9c1d105f1501248e7851bf19f6c959fc8dd',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        },
        {
          id: 5,
          clazz: '分类1',
          group: '分组1',
          picName: '标题1',
          createBy: 'zgh',
          imgUrl: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng27ff8791cb506042fcbe0e1e899de9c1d105f1501248e7851bf19f6c959fc8dd',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        }, {
          id: 6,
          clazz: '分类2',
          group: '分组2',
          picName: '标题2',
          createBy: 'zgh',
          imgUrl: 'http://image.test.laodao.so/image/goods/about/c7784681-f9e8-11ec-ae1a-9f2937d7f3ac.PNG',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        },
        {
          id: 7,
          clazz: '分类1',
          group: '分组1',
          picName: '标题1',
          createBy: 'zgh',
          imgUrl: 'http://image.test.laodao.so/image/goods/about/c7784681-f9e8-11ec-ae1a-9f2937d7f3ac.PNG',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        }, {
          id: 8,
          clazz: '分类2',
          group: '分组2',
          picName: '标题2',
          createBy: 'zgh',
          imgUrl: 'http://image.test.laodao.so/image/goods/about/c7784681-f9e8-11ec-ae1a-9f2937d7f3ac.PNG',
          createTime: '2022-10-10 12:00:00',
          pic: '',
        },
      ]
      this.datalist.map(item => {
        this.$set(item, 'isSelected', false)
      })
    },
    itemDelete (item, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk: () => {
          this.datalist.splice(index, 1)
        },
      })
    },
    choicePic (item) {
      this.clickItem2ShowPicModal = item
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.clickItem2ShowPicModal.picurl = pic.url
        //图片选择,选择图片时,需要上传这个链接;非选择图片,需要为空
        this.clickItem2ShowPicModal.contentLink = pic.linkurl
        this.clickItem2ShowPicModal.width = pic.width
        this.clickItem2ShowPicModal.height = pic.height
      }
    },

    deleteChoicePice (item) {
      if (item) {
        item.picurl = ''
        item.contentLink = ''
      }
    },

    showMaterialModal (item, index) {
      this.clickItem2ShowMaterialModal = item
      this.$refs.materialChoiceWidget.show()
    },

    materialChoiceOk (data) {
      if (data && data.length > 0) {
        let item = this.clickItem2ShowMaterialModal
        item.jumpObj.linkUrl = data[0].url
        this.$nextTick(() => {
          this.checkInputOverflow()
        })
      }
    },

    /**
     * input输入框是否超出
     */
    checkInputOverflow (item) {
      let input = document.getElementById('input')
      if (input) {
        this.showTooltip = input.clientWidth < input.scrollWidth
      }
    },

    /**
     * 获取最低显示数量
     */
    getMinCount () {
      let minCount = 2
      let displayType = this.iteminfo.config.displayType
      if (displayType === 2) { //卡片式
        minCount = 4
      } else if (displayType === 1) { //图标式
        minCount = 4
      } else if (displayType === 3) { //轮播图
        minCount = 4
      }
      return minCount
    },

    /**
     * 空item
     */
    getEmptyItem () {
      let item =  {
        id: 0,
        picurl: '',
        name: '',
        width: 0,
        height: 0,
        jumpObj: {
          linkUrl: '',
          linkName: '',
          shareTitle: '',
          shareCover: '',
          showVideoTitle: 0,
          showTime: 0,
          displayType: 1,
          subDisplayType: 1,
          ratio: 2,
          hSpacing: 0,
          vSpacing: 0,
          pSee: 1,
          pPublish: 1,
          pDevices: 1,
          pUsers: [],
          columnCount: 2,
        }
      }
      //导航图标式默认标题
      let info = this.iteminfo
      if (info.typeId === 2 && info.config.displayType === 1){
        item.name = '导航' + (this.iteminfo.config.datalist.length +1)
      }
      return item
    }

  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.item {
  width: 140px;
  height: 170px;
  flex-direction: row;
  margin-bottom: 10px;
}

.item-selected {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid #0EA4FB;
}

.item-normal {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid white;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.link-span {
  color: #333;
  font-size: 13px;
  line-height: 30px;
  padding-left: 5px;
  background-color: white;
  //white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 1; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
  pointer-events: auto;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
  border: 1px solid #dcdee2;
}

.input-link ::v-deep {
  .ivu-input-group-append {
    border: none;
  }
}
</style>
